import styled from 'styled-components';
import { AppStyledProps } from '../../../../../types';

type T = AppStyledProps;

export const ResultStyled = styled.div<T>`
  font-size: 1em;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin-bottom: 1em;

  & > div {
    margin-right: 0.4em;
  }
`;
